import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import zh from './zh'

Vue.use(VueI18n)

// 实例化 i18n
const i18n = new VueI18n({
    locale: 'zh', // 默认语言
    fallbackLocale: 'en', // 当默认语言不存在对应翻译时，使用的备用语言
    messages: {
        en,
        zh
    }
})

export default i18n
